module.exports = __webpack_public_path__ + "img/AT0000002401410.b90d143d.png";